import ProductRankingServices from '../../../../Services/ProductRankingServices';
import ImpersonatingServices from '../../../../Services/ImpersonatingServices';
import SystemServices from '../../../../Services/SystemServices';
import CrossSellUpSellServices from '../../../../Services/CrossSellUpSellServices';
// import AccountTenantServices from '../../../../Services/AccountTenantServices';
import ProductEMerchServices from '../../../../Services/ProductEMerchServices';
import { getCheckIfIsAValidUrl } from '../../Recommendations/services/recommendationsServices';
import ShopifyManualSortingServices from '../../../../Services/ShopifyManualSortingServices';

export function crudEmerchRanking($http, $rootScope, $timeout, $routeParams, AuthServices, shopifyManualSortingServices: ShopifyManualSortingServices) {
	const impersonatingServices = new ImpersonatingServices($rootScope, $routeParams);
	const impersonatedAccount = impersonatingServices.getImpersonatedAccount();
	const accountId = impersonatedAccount || $rootScope.User.Account.Key;
	const systemServices = new SystemServices($rootScope, $timeout);
	const isAdmin = impersonatingServices.isAnAdmin();

	const productRankingServices = new ProductRankingServices($http, AuthServices, accountId);
	// const accountTenantServices = new AccountTenantServices($http, AuthServices, accountId);
	const crossSellUpSellServices = new CrossSellUpSellServices($http);
	// const recoServices = new ProductEMerchServices($http, AuthServices, accountId);

	const recoServices = new ProductEMerchServices(
		$http,
		AuthServices,
		accountId
	);
	const getProductCollation = (category, callbackSuccess) =>
		productRankingServices.getProductCollation(category, callbackSuccess, () => systemServices.showError());

	const getProductFeedCategory = (accountId, tenant, callbackSuccess) =>
		crossSellUpSellServices.getProductFeedCategory(accountId, tenant, callbackSuccess, () => systemServices.showError());

	const getRankingById = (rankingId, callbackSuccess, callbackError) => {
		const handleError = (error) => {
			systemServices.showError();
			callbackError(error);
		};
		shopifyManualSortingServices.canUseShopifyManualSorting(canUse => {
			if (!canUse) return productRankingServices.getRankingById(rankingId, callbackSuccess, handleError);
			else return productRankingServices.getRankingByIdShopify(rankingId, callbackSuccess, handleError);
		}, handleError);
	};

	const getPreview = (options, paginationOptions, ranking, callbackSuccess, callbackError) => {
		const handleError = (error) => {
			systemServices.showError();
			callbackError(error);
		};
		shopifyManualSortingServices.canUseShopifyManualSorting(canUse => {
			if (!canUse) return productRankingServices.getProductListPreview(options, paginationOptions, ranking, callbackSuccess, handleError);
			else return productRankingServices.getProductListPreviewShopify(options, paginationOptions, ranking, callbackSuccess, handleError);
		}, handleError);
	};


	const createRanking = (ranking, callbackSuccess, callbackError) => {
		const handleError = (error) => {
			systemServices.showError();
			callbackError(error);
		};
		shopifyManualSortingServices.canUseShopifyManualSorting(canUse => {
			if (!canUse) return productRankingServices.createRanking(ranking, callbackSuccess, handleError);
			else return productRankingServices.createRankingShopify(ranking, callbackSuccess, handleError);
		}, handleError);
	};

	const putRankingById = (ranking, rankingId, callbackSuccess, callbackError) => {
		const handleError = (error) => {
			systemServices.showError();
			callbackError(error);
		};
		shopifyManualSortingServices.canUseShopifyManualSorting(canUse => {
			if (!canUse) return productRankingServices.putRankingById(ranking, rankingId, callbackSuccess, handleError);
			else return productRankingServices.putRankingByIdShopify(ranking, rankingId, callbackSuccess, handleError);
		}, handleError);
	};


	const deleteRankingById = (rankingId, callbackSuccess, callbackError) => {
		const handleError = (error) => {
			systemServices.showError();
			callbackError(error);
		};
		productRankingServices.deleteRanking(rankingId, () => {
			callbackSuccess();
			systemServices.showSuccess('The rule has been deleted.');
		}, handleError);
	};


	const duplicateRankingById = (rankingId, routeParams, functionToLoad, _callbackSuccess, callbackError) => {
		const handleError = (error) => {
			systemServices.showError();
			callbackError(error);
		};
		const handleSuccess = (Success) => {
			let ka = '';
			if (routeParams && routeParams.hasOwnProperty('ka') && isAdmin) {
				ka = '&ka=' + routeParams.ka;
			}
			systemServices.showSuccess('The rule has been duplicated, redirect to the edition screen');
			functionToLoad('/ProductSettings/Ranking/Setting?id=' + Success.id + ka);
		};

		productRankingServices.getRankingById(rankingId, (rule) => {
			const cloneRankingRule = { ...rule };
			cloneRankingRule.name = cloneRankingRule.name + ' cloned';
			productRankingServices.createRanking(cloneRankingRule, handleSuccess, handleError);
		}, handleError);
	};



	const getCheckIfIsAValidUrlFetch = async (url) => {
		return new Promise((resolve) => {
			getCheckIfIsAValidUrl(
				url,
				systemServices,
				recoServices,
				(_data) => {
					resolve({
						boolean: true,
						errorMessage: null
					});
				},
				(_error, dataErr) => {

					resolve({
						boolean: false,
						errorMessage: dataErr.data
					});
				}
			);
		});
	};
	return {
		getProductCollation,
		getProductFeedCategory,
		getRankingById,
		getPreview,
		createRanking,
		putRankingById,
		deleteRankingById,
		duplicateRankingById,
		getCheckIfIsAValidUrlFetch
	};
}